import React from 'react';
import {
  Container, Row, Card, CardBody, Table
} from 'reactstrap';
import Slider from 'react-slide-out';
import 'react-slide-out/lib/index.css';
import * as env from "../../../../env";
import { columnHeader } from "./config";
import Pagination from "../../../../shared/components/pagination/Pagination";
import FormComponent from "./form";
import MoreActions from "./MoreActions";
import { Link } from "react-router-dom";
import client from "../../../../shared/api-client";
import * as nodes from "../../../../shared/service/nodes";
import Modal from "../../../../shared/modal";
import * as validate from "../../../../shared/validate";

class ProxyNodes extends React.Component {
  state = {
    title: 'Nodes',
    addTitle: 'Add Node',
    editTitle: 'Edit Node',
    isOpen: false,
    results : [],
    filteredResults : [],
    columnHeader: columnHeader,
    filters: [],
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    show: false,
    success: '',
    errors: [],
    formValues: []
  };

  getResults() {
    nodes.get().then((response) => this.setResults(response));
  }

  handleForm = (formValues) => {
    this.setState({ formValues }, () => {
      // Validations will be added here if required frontend validations
    });
  };

  submit = () => {
    let errors = [];

    if (this.state.formValues.name === undefined || !validate.required(this.state.formValues.name)) {
      errors.push('Please enter the name.');
    }

    if (this.state.formValues.state === undefined || !validate.required(this.state.formValues.state)) {
      errors.push('Please enter the state.');
    }

    if (this.state.formValues.provider === undefined || !validate.required(this.state.formValues.provider)) {
      errors.push('Please enter the provider.');
    }

    if (this.state.formValues.server === undefined || !validate.required(this.state.formValues.server)) {
      errors.push('Please enter the server.');
    }

    if (this.state.formValues.ip === undefined 
      || !validate.required(this.state.formValues.ip)
      || !validate.ip(this.state.formValues.ip)) {
      errors.push('Please enter valid IP.');
    }

    if (this.state.formValues.type === undefined || !validate.required(this.state.formValues.type)) {
      errors.push('Please enter the type.');
    }

    if (this.state.formValues.root === undefined || !validate.required(this.state.formValues.root)) {
      errors.push('Please enter the root.');
    }

    if (this.state.formValues.cores === undefined 
      || !validate.required(this.state.formValues.cores)
      || !validate.number(this.state.formValues.cores)) {
      errors.push('Please enter integer value for cores.');
    }

    if (errors.length > 0) {
      this.setState({
        show: true,
        success: "",
        errors: errors,
      });

      return false;
    }

    let method = "PUT";

    if (this.state.editable !== undefined && this.state.editable.lid !== undefined) {
      method = "POST";
    }
  
    client(`nodes.php`, {
      method: method,
      body: this.state.formValues,
    }).then(
      (response) => {
        this.getResults();
        this.toggleAddNew();
        this.setState({
          show: true,
          errors: [],
          success: response._user_message
        });
      },
      (errors) => {
        this.setState({
          show: true,
          errors: errors._user_message,
          success: ""
        });
      }
    );
  };

  setResults = (results) => {
    this.setState({
      isOpen: false,
      results : results,
      filteredResults: results
    });
  }

  componentDidMount() {
    this.getResults();
  }

  formChangeHandler = (event) => {
    let filters = this.state.filters;
    let filter = {'name' : event.target.name, 'value' : event.target.value};

    var foundIndex = filters.findIndex(x => x.name === filter.name);

    if (foundIndex >= 0) {
      filters[foundIndex] = filter;
    } else {
      filters.push(filter);
    }

    this.setState({filters});
    this.filterResults();
  }

  filterResults = () => {
    let filteredResults = this.state.results;

    this.state.filters.forEach((element, index) => {
      if (element.value.trim() !== '') {
        filteredResults = filteredResults.filter(o =>
          Object.keys(o).some(k => String(o[element.name]).toLowerCase().includes(String(element.value).toLowerCase()))
        ); 
      }
    });
    
    this.setState({filteredResults});
  }

  printFilters = () => {
    return (<tr >
      {this.state.columnHeader.map(data => (data.filter) ? (<th key={data.key} > {this.printFilterInput(data)}</th>): <th></th>)}
    </tr>);
  }

  printFilterInput = (input) => {
    return (<input name={input.key} type="text" onChange={this.formChangeHandler}></input>);
  }

  printOptions = (key) => {
    return <React.Fragment>
      {this.state.filterValues[key].map(value => ( <option value={value}>{value}</option> ))}
    </React.Fragment>
  };

  usersListingUrl = (node) => {
    return `/proxy/locations/users/${node.lid}`
  }

  printRecords = () => {
    let items = this.state.filteredResults.slice(this.state.startIndex, this.state.endIndex + 1);

    return (<React.Fragment>
      {items.map(data => (
        <tr key={data.lid}>
          {this.state.columnHeader.map(header => (
            <td>
              {header.key === 'subnets' 
                ? <Link to={() => { return this.subnetsListingUrl(data)}} >{data.subnets}</Link> :  
                header.key === 'users' ?
                <Link to={() => { return this.usersListingUrl(data)}} >{data.users}</Link>
                : data[header.key]}
            </td>
          ))}
          <td><MoreActions onEditClicked={() => (this.toggleEdit(data))}  item={data} /></td>
        </tr>
      ))}
    </React.Fragment>
  );
}

subnetsListingUrl = (node) => {
  return `/proxy/node-subnets/${node.lid}`
}

pagination = () => {
  return this.state.filteredResults.length > env.RECORDS_PER_PAGE ? (
    <div className="audit-trail-footer">
      <Pagination
        items={this.state.filteredResults}
        onChangePage={(pagination) => this.setState(pagination)}
        pageSize={env.RECORDS_PER_PAGE}
      />
    </div>
  ) : (
    ""
  )
}

toggleAddNew = () => {
  this.setState(prevState => ({ isOpen: !prevState.isOpen }));
}

toggleEdit = (editable) => {
  this.setState({editable});
  this.setState(prevState => ({ isOpen: !prevState.isOpen}));
}

printActions = () => {
  return <React.Fragment>
    <button type="button" onClick={() => {
        let editable = {};
        this.setState({editable});
        this.toggleAddNew() 
      }} className="btn btn-sm btn-primary">{this.state.addTitle}</button>
  </React.Fragment>
}

  render() {
    return (
      <Container>
        <Row className="user-section">
          <Card className="table-section form">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.state.title}</h5>
                <div className="toolbar-buttons">
                  {this.printActions()}
                </div>
              </div>
              <Table responsive hover className="table--head-accent table--bordered">
                <thead>
                  <tr>
                    {this.state.columnHeader.map(data => (<th key={data.key}>{data.name}</th>))}
                  </tr>
                  {this.printFilters()}
                </thead>
                <tbody >
                  {this.printRecords()}
                </tbody>
              </Table>
              {this.pagination()}
            </CardBody>
          </Card>
        </Row>
        <Slider
          isOpen={this.state.isOpen}
          footer={(
            <div className="button-container">
              <button className="square btn btn-primary btn-sm" onClick={() => this.submit()} type="button">Submit</button>
              <button type="button" className="square btn btn-danger btn-sm" onClick={() => this.toggleAddNew()}>
                Cancel
              </button>
            </div>
          )}
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          {<FormComponent 
            title={(this.state.editable !== undefined && this.state.editable.lid !== undefined ) ? this.state.editTitle : this.state.addTitle} 
            toggleAddNew={this.toggleAddNew} 
            handleForm={(formValues) => this.handleForm(formValues)} 
            edit={() => {
              return this.state.editable;
            }} /> }
        </Slider>
        <Modal
          onClose={() => this.setState({ show: false })}
          show={this.state.show}
          errors={this.state.errors}
          success={this.state.success}
        ></Modal>
      </Container>
    );
  }
}

export default ProxyNodes;